import { PersonaCostType } from '../Models';

export const personaCostTypeLabelMap = {
    participant_time: 'Participant Time',
    participant_bloodVolume: 'Blood Volume',
    site_time: 'Site Time',
    site_relativeValueUnits: 'Complexity',
    sponsor_monetary: 'Activity Cost',
};

export const personaCostTypeValues: PersonaCostType[] = [
    'participant_time',
    'participant_bloodVolume',
    'site_time',
    'site_relativeValueUnits',
    'sponsor_monetary',
];

export const personaCostTypeOptions = personaCostTypeValues.map(value => ({
    label: personaCostTypeLabelMap[value],
    value,
}));
